import { PurchaseOrderActions } from "@finway-group/shared/lib/models/purchaseOrder/purchaseOrderStatusAction.enum"
import { Button, ButtonProps } from "antd"
import React from "react"
import { useModal } from "Shared/context/modal.context"
import { usePurchaseOrderTransition } from "../hooks/usePurchaseOrderTransition.hook"
import { RejectModal, RejectModalFormValues } from "./rejectModal"

type ModalConfirmationConfig = Pick<React.ComponentProps<typeof RejectModal>, "title" | "message" | "okText" | "cancelText" | "placeholder">

interface PurchaseOrderActionButtonProps extends Pick<ButtonProps, "type" | "color" | "icon" | "className"> {
    label: string
    purchaseOrderId: string
    purchaseOrderAction?: PurchaseOrderActions
    isDisabled: boolean
    rejectConfirmation?: ModalConfirmationConfig
    preApproveConfirmation?: () => Promise<boolean>
}

export const PurchaseOrderActionButton = ({
    label,
    purchaseOrderId,
    purchaseOrderAction,
    isDisabled,
    rejectConfirmation,
    preApproveConfirmation,
    ...props
}: PurchaseOrderActionButtonProps) => {
    const { transitionPO, isLoading } = usePurchaseOrderTransition()
    const { showModal } = useModal()
    const handleClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault()
        e.stopPropagation()

        if (preApproveConfirmation) {
            const confirmed = await preApproveConfirmation()
            if (!confirmed) {
                return
            }
        }
        if (rejectConfirmation) {
            showModal(RejectModal, true, {
                isShowing: true,
                title: rejectConfirmation.title,
                message: rejectConfirmation.message,
                okText: rejectConfirmation.okText,
                cancelText: rejectConfirmation.cancelText,
                onSubmit: async (values: RejectModalFormValues) => {
                    if (purchaseOrderAction) {
                        await transitionPO(purchaseOrderId, { action: purchaseOrderAction, reason: values.reasonToReject })
                    }
                },
                placeholder: rejectConfirmation.placeholder,
            })
            return
        }

        if (purchaseOrderAction) {
            await transitionPO(purchaseOrderId, { action: purchaseOrderAction })
        }
    }

    return (
        <Button {...props} onClick={handleClick} loading={isLoading} disabled={isDisabled || isLoading} data-testid="finway:purchaseOrder:action-btn">
            {label}
        </Button>
    )
}
